module.exports = __webpack_public_path__ + "img/vegetable-arugula-350x184.c19ec7f7.jpg";